export const DESIGN_PATH = '/app/settings/design';
/** Editing is a route so the sidebar can collapse for it. */
export const DESIGN_NEW_PATH = '/app/settings/design/new';
export const DESIGN_EDIT_PATTERN = '/app/settings/design/:designId/edit';
/** Where the one brand was edited before an agency could keep several designs. */
export const LEGACY_DESIGN_EDIT_PATH = '/app/settings/design/edit';

export const designEditPath = (designId: string) => `${DESIGN_PATH}/${designId}/edit`;
